(function() {
    document.addEventListener('DOMContentLoaded', function () {
        Telescope.loadApplication({
            parentId: 'big-brother-vote',
            url: 'https://bigbrothervote.votenow.tv/'
        });
    });
})();
